// Social Share - Facebook
// popup that scrapes OG tags

export default function (btn) {
  function init () {
    registerEvents();
  }

  function registerEvents () {
    btn.on('click', function (e) {
      e.preventDefault();

      let url = encodeURIComponent(window.location.href);
      let shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;

      window.open(shareUrl, '_blank', 'toolbar=yes, scrollbars=yes, resizable=yes, width=530, height=420');
    });
  }

  init();
}
